module.exports = __webpack_public_path__ + "img/tayaya-view.b4ce0eb9.jpg";